export enum DocumentTypeEnum {
  PolicyDocument = "InsPolicyDoc",
  OfferLetter = "InsCliOfferLetter",
}
